/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import { useNavigate} from "react-router-dom";
import {getUserByToken, register} from '../core/_requests'
import {useAuth} from '../core/Auth'
import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST

const initialValues = {
 
  
}

const registrationSchema = Yup.object().shape({
  
 acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

export function IntermediatePage() {
  
  const navigate = useNavigate();
  const [authTokens, setAuthTokens] = useState("");
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  const [formData, setFormData] = useState({});

  const handleInputChange = (event:any) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    });
  };
  const getTokenFromLocal =() =>{
  const token = localStorage.getItem("api_token")
  if(token){
    console.log(token)
    setAuthTokens(token)
  }
}
useEffect (()=>{
  getTokenFromLocal()
},[authTokens])
let uid = localStorage.getItem("uid") || undefined

  const handleAccept = async() => {
  
    const {data: user} = await getUserByToken(authTokens)
    console.log(user)
    
    setCurrentUser(user)

    const data ={
      temp_property_request_uuid:uid,
      temp_property_request_status:1
    }
  
     await axios.post(`${LOCAL_URL}/propertyRequestUpdate`,data)

    navigate('/update-profile')
    // Code to handle acceptance of form data
  };

  const handleDecline = async() => {
    const {data: user} = await getUserByToken(authTokens)
    console.log(user)
    setCurrentUser(user)
    const data ={
      temp_property_request_uuid:uid,
      temp_property_request_status:2
    }
  
   
   await axios.post(`${LOCAL_URL}/propertyRequestUpdate`,data)
    navigate('/dashboard')
    // Code to handle decline of form data
  };

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
       
        navigate('/dashboard')
        // const {data: auth} = await register(
        //   values.email,
        //   values.firstname,
        //   values.lastname,
        //   values.password,
        //   values.changepassword
        // )
        // saveAuth(auth)
        // const {data: user} = await getUserByToken(auth.api_token)
        // setCurrentUser(user)
      } catch (error) {
        console.error(error)
        // saveAuth(undefined)
        // setStatus('The registration details is incorrect')
        // setSubmitting(false)
        // setLoading(false)
      }
    },
  })

  useEffect(() => {
    //PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>Invitation</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        {/* end::Title */}
      </div>
      {/* end::Heading */}

   

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

  











      {/* begin::Form group */}
      {/* <div className='fv-row mb-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <span>
            I Accept the{' '}
            <a
              href='https://keenthemes.com/metronic/?page=faq'
              target='_blank'
              className='ms-1 link-primary'
            >
              Terms
            </a>
            .
          </span>
        </label>
        {formik.touched.acceptTerms && formik.errors.acceptTerms && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.acceptTerms}</span>
            </div>
          </div>
        )}
      </div> */}
      {/* end::Form group */}
      <div className='text-center'>
      <button type="button" className='btn btn-lg btn-primary w-45  mb-5 rounded hover-scale' style={{marginRight:'10px'}}   onClick={handleDecline}>Decline</button>
      <button type="button"  className='btn btn-lg btn-primary w-45 mb-5 rounded hover-scale '  onClick={handleAccept} >Accept</button>
      </div>
  
    </form>
  )
}
